

















































import Vue, { PropType } from 'vue'
import HomeDashboardTile from '@/types/components/HomeDashboardTile.interface'
export default Vue.extend({
    props: {
        tile: {
            type: Object as PropType<HomeDashboardTile>,
            required: true
        }
    },
    computed: {
        tileButtonColor(): string {
            //  Check if the button is disabled
            const disabled = this.tile.button.disabled

            //  If it is, then return our disabled color
            if (disabled) return 'rgba(0,0,0,0.26)'

            //  Else, return the tile's color
            return this.tile.button.color
        },
        tileButtonTextColor(): string {
            //  Check if the button is disabled
            const disabled = this.tile.button.disabled

            //  If it is, then return our disabled color
            if (disabled) return 'rgba(0,0,0,0.26)'

            //  Else, return the tile's color
            return this.tile.button.textColor
        },
        widthStyle(): string {
            //  Grab our breakpoint
            const bp = this.$vuetify.breakpoint.name

            //  Depending on our current breakpoint we have a different style for width
            const style =
                {
                    sm: 'width: 600px;',
                    md: 'width: 800px;',
                    lg: 'width: 800px;',
                    xl: 'width: 800px;'
                }[bp] || ''

            //  Return our style
            return style
        }
    },
    methods: {
        disabledPopup(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Access Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        onTileClick(): void {
            if (this.tile.callback && !this.tile.disabled) this.tile.callback()
        },
        onTileButtonClick(): void {
            //  Check if we are disabled
            const disabled = this.tile.button.disabled

            //  If we are, pop a disabled popup
            if (disabled) return this.disabledPopup()

            //  Else, do our callback
            this.tile.button.callback()
        }
    }
})
